import Slider, { CustomArrowProps } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { FC, useEffect, useState, useRef, CSSProperties } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import { useLenis } from "../components/LenisProvider";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Shared animation utility
const useIntersectionAnimation = (
  sectionRef: React.RefObject<HTMLElement | null>,
  elements: Array<{
    ref: React.RefObject<HTMLElement | null>;
    delay: number;
    initialStyles?: CSSProperties;
  }>,
  options: IntersectionObserverInit = { threshold: 0.1, rootMargin: "-50px" },
) => {
  useEffect(() => {
    elements.forEach(({ ref, initialStyles }) => {
      if (ref.current && initialStyles) {
        Object.assign(ref.current.style, initialStyles);
      }
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          elements.forEach(({ ref, delay }) => {
            setTimeout(() => {
              if (ref.current) {
                ref.current.style.opacity = "1";
                ref.current.style.transform = "translateY(0)";
              }
            }, delay);
          });
        }
      });
    }, options);

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [sectionRef, elements]);
};

// // Countdown component
// const CenturyCountdown: FC = () => {
//   const [counts, setCounts] = useState({ years: 0, projects: 0, families: 0 });
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const headingRef = useRef<HTMLHeadingElement>(null);
//   const descriptionRef = useRef<HTMLParagraphElement>(null);
//   const statsRef = useRef<HTMLDivElement>(null);

//   const targets = { years: 17, projects: 13, families: 1000 };

//   const animateCount = (
//     key: keyof typeof counts,
//     target: number,
//     duration: number,
//   ) => {
//     let start = 0;
//     const increment = target / (duration / 50);
//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= target) {
//         setCounts((prev) => ({ ...prev, [key]: target }));
//         clearInterval(timer);
//       } else {
//         setCounts((prev) => ({ ...prev, [key]: Math.ceil(start) }));
//       }
//     }, 50);
//   };

//   const startCountdown = () => {
//     setCounts({ years: 0, projects: 0, families: 0 });
//     setTimeout(() => {
//       Object.entries(targets).forEach(([key, value]) =>
//         animateCount(key as keyof typeof counts, value, 2000),
//       );
//     }, 100);
//   };

//   useIntersectionAnimation(sectionRef, [
//     {
//       ref: headingRef,
//       delay: 0,
//       initialStyles: {
//         opacity: "0",
//         transform: "translateY(20px)",
//         transition: "opacity 0.8s ease, transform 0.8s ease",
//       },
//     },
//     {
//       ref: descriptionRef,
//       delay: 200,
//       initialStyles: {
//         opacity: "0",
//         transform: "translateY(30px)",
//         transition: "opacity 1s ease 0.2s, transform 1s ease 0.2s",
//       },
//     },
//     {
//       ref: statsRef,
//       delay: 400,
//       initialStyles: {
//         opacity: "0",
//         transform: "translateY(40px)",
//         transition: "opacity 1.2s ease 0.5s, transform 1.2s ease 0.5s",
//       },
//     },
//   ]);

//   useEffect(() => {
//     const statsObserver = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) startCountdown();
//       },
//       { threshold: 0.1 },
//     );
//     if (statsRef.current) statsObserver.observe(statsRef.current);
//     return () => {
//       if (statsRef.current) statsObserver.unobserve(statsRef.current);
//     };
//   }, []);

//   return (
//     <div
//       ref={sectionRef}
//       className="mt-20 bg-white text-center"
//       style={{ fontFamily: "Gambetta" }}
//     >
//       <h1
//         ref={headingRef}
//         className="mx-6 my-6 mb-12 text-2xl font-bold tracking-widest text-[#363636]"
//       >
//         Where Vision Meets Excellence
//       </h1>
//       <p
//         ref={descriptionRef}
//         className="mx-auto mb-12 max-w-[90vw] text-2xl leading-10 tracking-wider text-black md:text-3xl lg:text-4xl 2xl:max-w-7xl"
//       >
//         Established in 2008, Century Group is a Premier Builder in Madhya
//         Pradesh, Delivering Excellence in Real Estate with Innovative Design,
//         Sustainability, and Trust.
//       </p>
//       <div
//         ref={statsRef}
//         className="mx-auto grid max-w-[90vw] grid-cols-1 items-center justify-items-center gap-x-12 gap-y-8 sm:grid-cols-3 lg:gap-x-0 2xl:max-w-7xl"
//         style={{ fontFamily: "GT-Ultra" }}
//       >
//         {[
//           { value: counts.years, label: "Years of Legacy" },
//           {
//             value: counts.projects,
//             label: "Million Square Foot<br /> Developed",
//           },
//           { value: counts.families, label: "Happy Families" },
//         ].map((stat, index) => (
//           <div key={index} className="flex flex-col items-center">
//             <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
//               {stat.value}+
//             </span>
//             <span
//               className="h-20 whitespace-nowrap text-xl text-black md:text-3xl"
//               dangerouslySetInnerHTML={{ __html: stat.label }}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const CenturyCountdown: FC = () => {
  // State to manage the counts for each metric
  const [years, setYears] = useState(0);
  const [projects, setProjects] = useState(0);
  const [families, setFamilies] = useState(0);
  // const [awards, setAwards] = useState(0);

  // Ref to track the section for Intersection Observer
  const sectionRef = useRef<HTMLDivElement>(null);
  const headingRef = useRef<HTMLHeadingElement>(null);
  const descriptionRef = useRef<HTMLParagraphElement>(null);
  const statsRef = useRef<HTMLDivElement>(null);

  // Target values for the countdown
  const targetYears = 17;
  const targetSQFT = 13;
  const targetFamilies = 1100;
  // const targetAwards = 60;

  // Function to animate the count
  const animateCount = (
    setCount: React.Dispatch<React.SetStateAction<number>>,
    target: number,
    duration: number,
  ) => {
    let start = 0;
    const increment = target / (duration / 50); // Adjust speed of animation
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, 50);
  };

  // Reset and start the countdown
  const startCountdown = () => {
    // Reset values first
    setYears(0);
    setProjects(0);
    setFamilies(0);
    // setAwards(0);

    // Start animations with small delay
    setTimeout(() => {
      animateCount(setYears, targetYears, 2000); // 2 seconds duration
      animateCount(setProjects, targetSQFT, 2000);
      animateCount(setFamilies, targetFamilies, 2000);
      // animateCount(setAwards, targetAwards, 2000);
    }, 100);
  };

  // Initialize animations for elements
  const resetAnimations = () => {
    if (headingRef.current) {
      headingRef.current.style.opacity = "0";
      headingRef.current.style.transform = "translateY(20px)";
    }

    if (descriptionRef.current) {
      descriptionRef.current.style.opacity = "0";
      descriptionRef.current.style.transform = "translateY(30px)";
    }

    if (statsRef.current) {
      statsRef.current.style.opacity = "0";
      statsRef.current.style.transform = "translateY(40px)";
    }
  };

  // Intersection Observer to detect when the section comes into view
  useEffect(() => {
    const lenis = (window as any).lenis;

    // Set initial styles
    if (headingRef.current) {
      headingRef.current.style.opacity = "0";
      headingRef.current.style.transform = "translateY(20px)";
      headingRef.current.style.transition =
        "opacity 0.8s ease, transform 0.8s ease";
    }

    if (descriptionRef.current) {
      descriptionRef.current.style.opacity = "0";
      descriptionRef.current.style.transform = "translateY(30px)";
      descriptionRef.current.style.transition =
        "opacity 1s ease 0.2s, transform 1s ease 0.2s";
    }

    if (statsRef.current) {
      statsRef.current.style.opacity = "0";
      statsRef.current.style.transform = "translateY(40px)";
      statsRef.current.style.transition =
        "opacity 1.2s ease 0.5s, transform 1.2s ease 0.5s";
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // When section enters viewport
          if (entry.isIntersecting) {
            if (entry.target === sectionRef.current) {
              // Animate heading when section becomes visible
              if (headingRef.current) {
                headingRef.current.style.opacity = "1";
                headingRef.current.style.transform = "translateY(0)";
              }

              // Animate description after a slight delay
              if (descriptionRef.current) {
                setTimeout(() => {
                  descriptionRef.current!.style.opacity = "1";
                  descriptionRef.current!.style.transform = "translateY(0)";
                }, 200);
              }

              // Animate stats section after another delay
              if (statsRef.current) {
                setTimeout(() => {
                  statsRef.current!.style.opacity = "1";
                  statsRef.current!.style.transform = "translateY(0)";
                }, 400);
              }
            }

            // Start countdown when stats section becomes visible
            if (entry.target === statsRef.current) {
              startCountdown();
            }
          }
          // When section exits viewport - reset animations
          else {
            if (entry.target === sectionRef.current) {
              resetAnimations();
            }
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px",
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    // Lenis scroll update listener for parallax effects
    if (lenis) {
      lenis.on(
        "scroll",
        // ({ scroll, limit, velocity, direction, progress }: any) => {
        () => {
          // Optional: Add parallax effects based on scroll position
          if (sectionRef.current) {
            const bounds = sectionRef.current.getBoundingClientRect();
            const inView = bounds.top < window.innerHeight && bounds.bottom > 0;

            if (inView) {
              // Parallax effect for description
              if (descriptionRef.current) {
                const offsetY = (bounds.top - window.innerHeight) * 0.05;
                descriptionRef.current.style.transform = `translateY(${Math.min(0, offsetY)}px)`;
              }
            }
          }
        },
      );
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }

      // Remove Lenis scroll listener if it exists
      if (lenis) {
        lenis.off("scroll");
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="mt-8 bg-white text-center lg:mt-12"
      style={{ fontFamily: "Gambetta" }}
    >
      <h1
        ref={headingRef}
        className="mx-6 mb-12 text-2xl font-bold tracking-widest text-[#363636]"
      >
        Where Vision Meets Excellence
      </h1>

      {/* Description */}
      <p
        ref={descriptionRef}
        className="mx-auto mb-12 max-w-[90vw] text-2xl leading-10 tracking-wider text-black md:text-3xl lg:text-4xl 2xl:max-w-7xl"
      >
        Established in 2008, Century Group is a Premier Builder in Madhya
        Pradesh, Delivering Excellence in Real Estate with Innovative Design,
        Sustainability, and Trust.
      </p>

      <div
        ref={statsRef}
        className="mx-auto grid max-w-[90vw] grid-cols-1 items-center justify-items-center gap-x-12 gap-y-8 sm:grid-cols-3 lg:gap-x-0 2xl:max-w-7xl"
        style={{ fontFamily: "GT-Ultra" }}
      >
        {/* Years of Legacy */}
        <div className="flex flex-col items-center">
          <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
            {years}+
          </span>
          <span className="h-20 whitespace-nowrap text-xl text-black md:text-3xl">
            Years of Legacy
          </span>
        </div>

        {/* Projects Delivered */}
        <div className="flex flex-col items-center">
          <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
            {projects}+
          </span>
          <span className="h-20 whitespace-nowrap text-xl text-black md:text-3xl">
            Million Square Foot
            <br /> Developed
          </span>
        </div>

        {/* Happy Families */}
        <div className="flex flex-col items-center">
          <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
            {families}+
          </span>
          <span className="h-20 whitespace-nowrap text-xl text-black md:text-3xl">
            Happy Families
          </span>
        </div>

        {/* Awards & Accolades */}
        {/* <div className="flex flex-col items-center">
          <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
            {awards}+
          </span>
          <span className="whitespace-nowrap text-xl text-black md:text-3xl">
            Awards & Accolades
          </span>
        </div> */}
      </div>
    </div>
  );
};

// Generic Carousel Component
const CarouselComponent: FC<{
  title: string;
  items: Array<{
    img: string;
    title?: string;
    description?: string;
    location?: string;
    galleryTab?: string;
  }>;
  settings: any;
  renderItem: (item: any, index: number) => React.JSX.Element;
}> = ({ title, items, settings, renderItem }) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const sliderRef = useRef<HTMLDivElement>(null);

  useIntersectionAnimation(sectionRef, [
    {
      ref: titleRef,
      delay: 0,
      initialStyles: {
        opacity: "0",
        transform: "translateY(30px)",
        transition: "opacity 0.8s ease, transform 0.8s ease",
      },
    },
    {
      ref: sliderRef,
      delay: 200,
      initialStyles: {
        opacity: "0",
        transform: "translateY(40px)",
        transition: "opacity 1s ease 0.3s, transform 1s ease 0.3s",
      },
    },
  ]);

  return (
    <div
      ref={sectionRef}
      className="container mx-auto my-32 max-w-[90vw]"
      style={{ fontFamily: "Gambetta" }}
    >
      <div className="mb-12 flex items-center justify-center">
        <h1
          ref={titleRef}
          className="text-3xl lg:text-5xl"
          style={{ fontFamily: "GT-Ultra" }}
        >
          {title}
        </h1>
      </div>
      <div ref={sliderRef} className="relative">
        <Slider {...settings}>{items.map(renderItem)}</Slider>
      </div>
    </div>
  );
};

// Arrow Components
const CustomPrevArrow: FC<CustomArrowProps> = ({ onClick }) => (
  <button
    className="absolute left-[-50px] top-1/2 z-10 -translate-y-1/2 text-[#1a4fa3] hover:text-[#d4af37] focus:outline-none"
    onClick={onClick}
    aria-label="Previous"
  >
    <img
      src="/assets/imgs/LeftArrow.svg"
      alt="Previous Arrow"
      className="w-5"
    />
  </button>
);

const CustomNextArrow: FC<CustomArrowProps> = ({ onClick }) => (
  <button
    className="absolute right-[-50px] top-1/2 z-10 -translate-y-1/2 text-[#1a4fa3] hover:text-[#d4af37] focus:outline-none"
    onClick={onClick}
    aria-label="Next"
  >
    <img src="/assets/imgs/RightArrow.svg" alt="Next Arrow" className="w-5" />
  </button>
);

// Key Business Carousel
const KeyBusiness: FC = () => {
  const settings = {
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const items = [
    {
      img: "/assets/imgs/Key Business/a.webp",
      title: "Real Estate",
      description: "Luxury, Comfort, and Community - All in One",
      galleryTab: "Nakshatra Nagar",
    },
    {
      img: "/assets/imgs/Key Business/resort5.webp",
      title: "Hospitality",
      description: "A Stay That Feels Like Home, Amidst Nature's Best",
      galleryTab: "Sanctuary Resort",
    },
    {
      img: "/assets/imgs/Key Business/_BDGS.jpg",
      title: "Education",
      description: "Shaping Young Minds for a Brighter Tomorrow",
      galleryTab: "BDGS",
    },
  ];

  const renderItem = (item: (typeof items)[0], index: number) => (
    <Link
      key={index}
      to={`/gallery?tab=${encodeURIComponent(item.galleryTab!)}`}
    >
      <div className="px-4 focus:outline-none">
        <div className="group relative cursor-pointer overflow-hidden rounded-lg transition-shadow hover:shadow-xl hover:shadow-black/30">
          <div className="h-96 w-auto">
            <img
              src={item.img}
              alt={item.title}
              className="h-full w-full cursor-pointer object-cover transition-transform duration-500 group-hover:scale-125"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70" />
          <div className="absolute inset-0 flex translate-y-[50%] flex-col items-center justify-center px-4 text-center transition-all duration-500 group-hover:translate-y-[30%]">
            <h1 className="text-2xl font-bold text-white">{item.title}</h1>
            <p className="mt-2 h-24 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              {item.description}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );

  return (
    <CarouselComponent
      title="Key Businesses"
      items={items}
      settings={settings}
      renderItem={renderItem}
    />
  );
};

// Ongoing Projects Carousel
const OngoingProjects: FC = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 3000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
        },
      },
    ],
  };

  const items = [
    {
      img: "/assets/imgs/Ongoing Projects/1.webp",
      location: "Nakshatra Nagar - Phase 3",
      galleryTab: "Nakshatra Nagar",
    },
    {
      img: "/assets/imgs/Ongoing Projects/2.webp",
      location: "Nakshatra Nagar - Phase 4",
      galleryTab: "Nakshatra Nagar",
    },
    {
      img: "/assets/imgs/Ongoing Projects/3.jpg",
      location: "Vijay Nagar, Jabalpur",
      galleryTab: "Star Park",
    },
  ];

  const renderItem = (item: (typeof items)[0], index: number) => (
    <Link
      key={index}
      to={`/gallery?tab=${encodeURIComponent(item.galleryTab!)}`}
    >
      <div key={index} className="px-4 focus:outline-none">
        <img
          src={item.img}
          alt={`Ongoing Project ${index + 1}`}
          className="h-80 w-full rounded-lg object-cover focus:outline-none"
        />
        <h1
          className="mt-4 flex items-center justify-center text-lg tracking-widest text-[#1a4fa3]"
          style={{ fontFamily: "HistoryPro" }}
        >
          <FaMapMarkerAlt className="mr-2" /> {item.location}
        </h1>
      </div>
    </Link>
  );

  return (
    <CarouselComponent
      title="Ongoing Developments"
      items={items}
      settings={settings}
      renderItem={renderItem}
    />
  );
};

// Leadership Carousel
const Leadership: FC = () => {
  const settings = {
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    arrows: false,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
        },
      },
    ],
  };

  const items = [
    {
      img: "/assets/imgs/About Us/Chairman_SJ.webp",
      name: "Mr. Sandesh Kumar Jain",
      title: "Chairman",
      id: "chairman",
    },
    {
      img: "/assets/imgs/About Us/MD.webp",
      name: "Mr. Samyak Jain",
      title: "Managing Director",
      id: "managing-director",
    },
    {
      img: "/assets/imgs/About Us/Kamesh.webp",
      name: "Dr. Kamesh Satish Pawar",
      title: "Chief Executive Officer",
      id: "ceo",
    },
  ];

  const lenis = useLenis(); // Get Lenis instance
  const navigate = useNavigate(); // For programmatic navigation

  const handleScrollTo = (id: string) => {
    // Navigate to the about-us page with the hash
    navigate(`/about-us#${id}`);

    // Use Lenis to scroll to the element with an offset
    if (lenis) {
      setTimeout(() => {
        lenis.scrollTo(`#${id}`, {
          offset: -100, // Adjust for navbar height (e.g., -100px)
          duration: 1.2, // Match Lenis duration
          easing: (t: number) => Math.min(1, 1.001 - Math.pow(1 - t, 4)), // Match Lenis easing
        });
      }, 100); // Small delay to ensure page navigation completes
    }
  };

  const renderItem = (item: (typeof items)[0], index: number) => (
    <div key={index} className="px-4 focus:outline-none">
      <div
        onClick={() => handleScrollTo(item.id)} // Use custom handler
        className="cursor-pointer"
      >
        <img
          src={item.img}
          alt={`Ongoing Project ${index + 1}`}
          className="h-80 w-full rounded-lg object-cover focus:outline-none"
        />
        <h1
          className="mt-4 flex items-center justify-center text-lg tracking-widest"
          style={{ fontFamily: "HistoryPro" }}
        >
          {item.name}
        </h1>
        <div className="mt-2">
          <p className="text-center text-[#1a4fa3]">{item.title}</p>
        </div>
      </div>
    </div>
  );

  return (
    <CarouselComponent
      title="Our Leadership"
      items={items}
      settings={settings}
      renderItem={renderItem}
    />
  );
};

const TestimonialCarousel: FC = () => {
  // State for selected video
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  // Ref for dialog element
  const dialogRef = useRef<HTMLDialogElement>(null);

  // Carousel settings
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    dots: true,
    slidesToScroll: 3,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  // Items array with YouTube video URLs
  const items = [
    {
      img: "/assets/imgs/Testimonials/1.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/KRtzLXqpm6U",
    },
    {
      img: "/assets/imgs/Testimonials/2.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/oBnOW1s2R1Q",
    },
    {
      img: "/assets/imgs/Testimonials/3.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/Cr5vAnVTQXU",
    },
    {
      img: "/assets/imgs/Testimonials/4.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/bgHzzVU7IUM",
    },
    {
      img: "/assets/imgs/Testimonials/5.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/gu4QH-laUoU",
    },
    {
      img: "/assets/imgs/Testimonials/6.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/mi7gezKpHLk",
    },
    {
      img: "/assets/imgs/Testimonials/7.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/Cx039VURwac",
    },
    {
      img: "/assets/imgs/Testimonials/8.webp",
      title: "Nakshtra Nagar Families",
      location: "Karmeta Jabalpur",
      videoUrl: "https://www.youtube.com/embed/_rDNGd7Y-_Q",
    },
  ];

  // Disable background scrolling when modal is open
  useEffect(() => {
    if (selectedVideo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedVideo]);

  // Handle thumbnail click
  const handleThumbnailClick = (videoUrl: string) => {
    setSelectedVideo(videoUrl);
    dialogRef.current?.showModal(); // Open dialog
  };

  // Close modal
  const closeModal = () => {
    setSelectedVideo(null);
    dialogRef.current?.close(); // Close dialog
  };

  // Handle outside click (backdrop click)
  const handleDialogClick = (event: React.MouseEvent<HTMLDialogElement>) => {
    if (event.target === dialogRef.current) {
      closeModal();
    }
  };

  // Render carousel item
  const renderItem = (item: (typeof items)[0], index: number) => (
    <div key={index} className="px-4 text-center focus:outline-none">
      <img
        src={item.img}
        alt={`Testimonial ${index + 1}`}
        className="w-full cursor-pointer rounded-lg object-cover focus:outline-none"
        onClick={() => handleThumbnailClick(item.videoUrl)}
      />
      <div className="mt-2">
        <p className="text-xl">{item.title}</p>
        <p className="text-[#1a4fa3]">{item.location}</p>
      </div>
    </div>
  );

  return (
    <>
      <CarouselComponent
        title="Voice of Trust"
        items={items}
        settings={settings}
        renderItem={renderItem}
      />
      {/* Dialog for video playback */}
      <dialog
        ref={dialogRef}
        onClick={handleDialogClick}
        className="w-[90%] max-w-[800px] rounded-lg bg-transparent p-0 backdrop:bg-black backdrop:bg-opacity-50"
      >
        <div className="relative">
          {/* Close button */}
          <button
            onClick={closeModal}
            className="absolute -top-8 right-0 text-2xl text-white focus:outline-none"
            aria-label="Close video modal"
          >
            ×
          </button>
          {/* YouTube iframe */}
          {selectedVideo && (
            <iframe
              width="100%"
              height="450"
              src={`${selectedVideo}?autoplay=1&rel=0&showinfo=0`}
              title="Testimonial Video"
              className="IFRAME"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </dialog>
    </>
  );
};

// Homepage Component
const Homepage: FC = () => {
  const slides = [
    { id: 1, image: "/assets/imgs/Hero Carousel/_1.webp", title: "Slide 1" },
    { id: 2, image: "/assets/imgs/Hero Carousel/_2.webp", title: "Slide 2" },
    { id: 3, image: "/assets/imgs/Hero Carousel/_3.webp", title: "Slide 3" },
  ];

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const isLoading = null;

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <section className="relative overflow-hidden" aria-label="Hero Section">
        {/* Hero Section Carousel */}
        <Slider {...settings}>
          {slides.map((slide) => (
            <div key={slide.id}>
              <img
                src={slide.image}
                alt={slide.title}
                className="z-[-1000] h-auto max-h-[75vh] w-full object-cover"
                loading="eager"
              />
            </div>
          ))}
        </Slider>

        <main>
          <CenturyCountdown />

          <section aria-label="Key Business Areas">
            <KeyBusiness />
          </section>

          <section aria-label="Ongoing Projects">
            <OngoingProjects />
          </section>

          <section aria-label="Leadership Team">
            <Leadership />
          </section>

          <section aria-label="Client Testimonials">
            <TestimonialCarousel />
          </section>
        </main>
      </section>
    </div>
  );
};

export default Homepage;

// import Slider, { CustomArrowProps } from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { FC, useEffect, useState, useRef } from "react";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { Link } from "react-router-dom";
// // import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// const CenturyCountdown: FC = () => {
//   // State to manage the counts for each metric
//   const [years, setYears] = useState(0);
//   const [projects, setProjects] = useState(0);
//   const [families, setFamilies] = useState(0);
//   // const [awards, setAwards] = useState(0);

//   // Ref to track the section for Intersection Observer
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const headingRef = useRef<HTMLHeadingElement>(null);
//   const descriptionRef = useRef<HTMLParagraphElement>(null);
//   const statsRef = useRef<HTMLDivElement>(null);

//   // Target values for the countdown
//   const targetYears = 17;
//   const targetSQFT = 13;
//   const targetFamilies = 1000;
//   // const targetAwards = 60;

//   // Function to animate the count
//   const animateCount = (
//     setCount: React.Dispatch<React.SetStateAction<number>>,
//     target: number,
//     duration: number,
//   ) => {
//     let start = 0;
//     const increment = target / (duration / 50); // Adjust speed of animation
//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= target) {
//         setCount(target);
//         clearInterval(timer);
//       } else {
//         setCount(Math.ceil(start));
//       }
//     }, 50);
//   };

//   // Reset and start the countdown
//   const startCountdown = () => {
//     // Reset values first
//     setYears(0);
//     setProjects(0);
//     setFamilies(0);
//     // setAwards(0);

//     // Start animations with small delay
//     setTimeout(() => {
//       animateCount(setYears, targetYears, 2000); // 2 seconds duration
//       animateCount(setProjects, targetSQFT, 2000);
//       animateCount(setFamilies, targetFamilies, 2000);
//       // animateCount(setAwards, targetAwards, 2000);
//     }, 100);
//   };

//   // Initialize animations for elements
//   const resetAnimations = () => {
//     if (headingRef.current) {
//       headingRef.current.style.opacity = "0";
//       headingRef.current.style.transform = "translateY(20px)";
//     }

//     if (descriptionRef.current) {
//       descriptionRef.current.style.opacity = "0";
//       descriptionRef.current.style.transform = "translateY(30px)";
//     }

//     if (statsRef.current) {
//       statsRef.current.style.opacity = "0";
//       statsRef.current.style.transform = "translateY(40px)";
//     }
//   };

//   // Intersection Observer to detect when the section comes into view
//   useEffect(() => {
//     const lenis = (window as any).lenis;

//     // Set initial styles
//     if (headingRef.current) {
//       headingRef.current.style.opacity = "0";
//       headingRef.current.style.transform = "translateY(20px)";
//       headingRef.current.style.transition =
//         "opacity 0.8s ease, transform 0.8s ease";
//     }

//     if (descriptionRef.current) {
//       descriptionRef.current.style.opacity = "0";
//       descriptionRef.current.style.transform = "translateY(30px)";
//       descriptionRef.current.style.transition =
//         "opacity 1s ease 0.2s, transform 1s ease 0.2s";
//     }

//     if (statsRef.current) {
//       statsRef.current.style.opacity = "0";
//       statsRef.current.style.transform = "translateY(40px)";
//       statsRef.current.style.transition =
//         "opacity 1.2s ease 0.5s, transform 1.2s ease 0.5s";
//     }

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           // When section enters viewport
//           if (entry.isIntersecting) {
//             if (entry.target === sectionRef.current) {
//               // Animate heading when section becomes visible
//               if (headingRef.current) {
//                 headingRef.current.style.opacity = "1";
//                 headingRef.current.style.transform = "translateY(0)";
//               }

//               // Animate description after a slight delay
//               if (descriptionRef.current) {
//                 setTimeout(() => {
//                   descriptionRef.current!.style.opacity = "1";
//                   descriptionRef.current!.style.transform = "translateY(0)";
//                 }, 200);
//               }

//               // Animate stats section after another delay
//               if (statsRef.current) {
//                 setTimeout(() => {
//                   statsRef.current!.style.opacity = "1";
//                   statsRef.current!.style.transform = "translateY(0)";
//                 }, 400);
//               }
//             }

//             // Start countdown when stats section becomes visible
//             if (entry.target === statsRef.current) {
//               startCountdown();
//             }
//           }
//           // When section exits viewport - reset animations
//           else {
//             if (entry.target === sectionRef.current) {
//               resetAnimations();
//             }
//           }
//         });
//       },
//       {
//         threshold: 0.1,
//         rootMargin: "0px",
//       },
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     if (statsRef.current) {
//       observer.observe(statsRef.current);
//     }

//     // Lenis scroll update listener for parallax effects
//     if (lenis) {
//       lenis.on(
//         "scroll",
//         // ({ scroll, limit, velocity, direction, progress }: any) => {
//         () => {
//           // Optional: Add parallax effects based on scroll position
//           if (sectionRef.current) {
//             const bounds = sectionRef.current.getBoundingClientRect();
//             const inView = bounds.top < window.innerHeight && bounds.bottom > 0;

//             if (inView) {
//               // Parallax effect for description
//               if (descriptionRef.current) {
//                 const offsetY = (bounds.top - window.innerHeight) * 0.05;
//                 descriptionRef.current.style.transform = `translateY(${Math.min(0, offsetY)}px)`;
//               }
//             }
//           }
//         },
//       );
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//       if (statsRef.current) {
//         observer.unobserve(statsRef.current);
//       }

//       // Remove Lenis scroll listener if it exists
//       if (lenis) {
//         lenis.off("scroll");
//       }
//     };
//   }, []);

//   return (
//     <div
//       ref={sectionRef}
//       className="mt-20 bg-white text-center"
//       style={{ fontFamily: "Gambetta" }}
//     >
//       <h1
//         ref={headingRef}
//         className="mx-6 my-6 mb-12 text-2xl font-bold tracking-widest text-[#363636]"
//       >
//         Where Vision Meets Excellence
//       </h1>

//       {/* Description */}
//       <p
//         ref={descriptionRef}
//         className="mx-auto mb-12 max-w-[90vw] text-2xl leading-10 tracking-wider text-black md:text-3xl lg:text-4xl 2xl:max-w-7xl"
//       >
//         Established in 2008, Century Group is a Premier Builder in Madhya
//         Pradesh, Delivering Excellence in Real Estate with Innovative Design,
//         Sustainability, and Trust.
//       </p>

//       <div
//         ref={statsRef}
//         className="mx-auto grid max-w-[90vw] grid-cols-1 items-center justify-items-center gap-x-12 gap-y-8 sm:grid-cols-3 lg:gap-x-0 2xl:max-w-7xl"
//         style={{ fontFamily: "GT-Ultra" }}
//       >
//         {/* Years of Legacy */}
//         <div className="flex flex-col items-center">
//           <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
//             {years}+
//           </span>
//           <span className="h-20 whitespace-nowrap text-xl text-black md:text-3xl">
//             Years of Legacy
//           </span>
//         </div>

//         {/* Projects Delivered */}
//         <div className="flex flex-col items-center">
//           <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
//             {projects}+
//           </span>
//           <span className="h-20 whitespace-nowrap text-xl text-black md:text-3xl">
//             Million Square Foot
//             <br /> Developed
//           </span>
//         </div>

//         {/* Happy Families */}
//         <div className="flex flex-col items-center">
//           <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
//             {families}+
//           </span>
//           <span className="h-20 whitespace-nowrap text-xl text-black md:text-3xl">
//             Happy Families
//           </span>
//         </div>

//         {/* Awards & Accolades */}
//         {/* <div className="flex flex-col items-center">
//           <span className="text-5xl font-bold text-[#1a4fa3] md:text-6xl lg:mb-8">
//             {awards}+
//           </span>
//           <span className="whitespace-nowrap text-xl text-black md:text-3xl">
//             Awards & Accolades
//           </span>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// const KeyBusiness: FC = () => {
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const titleRef = useRef<HTMLHeadingElement>(null);
//   const carouselRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     // Initialize animations
//     if (titleRef.current) {
//       titleRef.current.style.opacity = "0";
//       titleRef.current.style.transform = "translateY(30px)";
//       titleRef.current.style.transition =
//         "opacity 0.8s ease, transform 0.8s ease";
//     }

//     if (carouselRef.current) {
//       carouselRef.current.style.opacity = "0";
//       carouselRef.current.style.transform = "translateY(40px)";
//       carouselRef.current.style.transition =
//         "opacity 1s ease 0.3s, transform 1s ease 0.3s";
//     }

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             if (entry.target === sectionRef.current) {
//               // Animate title
//               if (titleRef.current) {
//                 titleRef.current.style.opacity = "1";
//                 titleRef.current.style.transform = "translateY(0)";
//               }

//               // Animate carousel
//               if (carouselRef.current) {
//                 setTimeout(() => {
//                   carouselRef.current!.style.opacity = "1";
//                   carouselRef.current!.style.transform = "translateY(0)";
//                 }, 200);
//               }
//             }
//           }
//         });
//       },
//       {
//         threshold: 0.1,
//         rootMargin: "-50px",
//       },
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div ref={sectionRef} className="my-32">
//       <h1
//         ref={titleRef}
//         className="mb-12 text-center text-3xl lg:text-5xl"
//         style={{ fontFamily: "GT-Ultra" }}
//       >
//         Key Businesses
//       </h1>
//       <div ref={carouselRef}>
//         <Carousel />
//       </div>
//     </div>
//   );
// };

// const Carousel: FC = () => {
//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 3,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           dots: true,
//           autoplay: true,
//           autoplaySpeed: 3000,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const items = [
//     {
//       img: "/Key Business/a.webp",
//       title: "Real Estate",
//       description: "Luxury, Comfort, and Community - All in One",
//       galleryTab: "Nakshatra Nagar",
//     },
//     {
//       img: "/Key Business/resort5.webp",
//       title: "Hospitality",
//       description: "A Stay That Feels Like Home, Amidst Nature's Best",
//       galleryTab: "Sanctuary Resort",
//     },
//     {
//       img: "/Key Business/_BDGS.jpg",
//       title: "Education",
//       description: "Shaping Young Minds for a Brighter Tomorrow",
//       galleryTab: "BDGS",
//     },
//   ];

//   return (
//     <div style={{ fontFamily: "Gambetta" }}>
//       <div className="relative">
//         <Slider {...settings}>
//           {items.map((item, index) => (
//             <Link to={`/gallery?tab=${encodeURIComponent(item.galleryTab)}`}>
//               <div key={index} className="px-4 focus:outline-none">
//                 <div className="group relative cursor-pointer overflow-hidden rounded-lg transition-shadow hover:shadow-xl hover:shadow-black/30">
//                   <div className="h-96 w-auto">
//                     <img
//                       src={item.img}
//                       alt={item.title}
//                       className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-125"
//                     />
//                   </div>
//                   <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70" />
//                   <div className="absolute inset-0 flex translate-y-[50%] flex-col items-center justify-center px-4 text-center transition-all duration-500 group-hover:translate-y-[30%]">
//                     <h3 className="text-2xl font-bold text-white">
//                       {item.title}
//                     </h3>
//                     <p className="mt-2 h-24 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
//                       {item.description}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// };

// const CustomPrevArrow: FC<CustomArrowProps> = ({ onClick }) => (
//   <button
//     className="absolute left-[-50px] top-1/2 z-10 -translate-y-1/2 text-[#1a4fa3] hover:text-[#d4af37] focus:outline-none"
//     onClick={onClick}
//     aria-label="Previous"
//   >
//     {/* <FaChevronLeft size={30} /> */}
//     <img src="/LeftArrow.svg" alt="Previous Arrow" className="w-5" />
//   </button>
// );

// const CustomNextArrow: FC<CustomArrowProps> = ({ onClick }) => (
//   <button
//     className="absolute right-[-50px] top-1/2 z-10 -translate-y-1/2 text-[#1a4fa3] hover:text-[#d4af37] focus:outline-none"
//     onClick={onClick}
//     aria-label="Next"
//   >
//     {/* <FaChevronRight size={30} /> */}
//     <img src="/RightArrow.svg" alt="Next Arrow" className="w-5" />
//   </button>
// );

// const MultipleItems: FC = () => {
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const titleRef = useRef<HTMLHeadingElement>(null);
//   const sliderRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     // Initialize animations
//     if (titleRef.current) {
//       titleRef.current.style.opacity = "0";
//       titleRef.current.style.transform = "translateY(30px)";
//       titleRef.current.style.transition =
//         "opacity 0.8s ease, transform 0.8s ease";
//     }

//     if (sliderRef.current) {
//       sliderRef.current.style.opacity = "0";
//       sliderRef.current.style.transform = "translateY(40px)";
//       sliderRef.current.style.transition =
//         "opacity 1s ease 0.3s, transform 1s ease 0.3s";
//     }

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             if (entry.target === sectionRef.current) {
//               // Animate title
//               if (titleRef.current) {
//                 titleRef.current.style.opacity = "1";
//                 titleRef.current.style.transform = "translateY(0)";
//               }

//               // Animate slider
//               if (sliderRef.current) {
//                 setTimeout(() => {
//                   sliderRef.current!.style.opacity = "1";
//                   sliderRef.current!.style.transform = "translateY(0)";
//                 }, 200);
//               }
//             }
//           }
//         });
//       },
//       {
//         threshold: 0.1,
//         rootMargin: "-50px",
//       },
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     // Access Lenis for smoother slide transitions
//     const lenis = (window as any).lenis;

//     // Optional: Add scroll-triggered effects for this section
//     if (lenis) {
//       lenis.on(
//         "scroll",
//         // ({ scroll, limit, velocity, direction, progress }: any) => {
//         () => {
//           if (sectionRef.current) {
//             const bounds = sectionRef.current.getBoundingClientRect();
//             if (bounds.top < window.innerHeight && bounds.bottom > 0) {
//               // Calculate how far the section is in view (0 to 1)
//               const sectionProgress = 1 - bounds.top / window.innerHeight;

//               // Apply subtle rotation based on scroll position
//               if (
//                 sliderRef.current &&
//                 sectionProgress > 0 &&
//                 sectionProgress < 1
//               ) {
//                 const rotateY = (sectionProgress - 0.5) * 2; // -1 to 1 range
//                 sliderRef.current.style.transform = `perspective(1000px) rotateY(${rotateY}deg)`;
//               }
//             }
//           }
//         },
//       );
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }

//       // Remove Lenis listener
//       if (lenis) {
//         lenis.off("scroll");
//       }
//     };
//   }, []);

//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     dots: true,
//     slidesToScroll: 3,
//     arrows: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     prevArrow: <CustomPrevArrow />,
//     nextArrow: <CustomNextArrow />,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const OngoingProjects = [
//     {
//       img: "/Ongoing Projects/1.webp",
//       location: "Nakshatra Nagar - Phase 3",
//     },
//     {
//       // img: "/Ongoing Projects/2.JPG",
//       img: "/Ongoing Projects/2.webp",
//       location: "Nakshatra Nagar - Phase 4",
//     },
//     {
//       img: "/Ongoing Projects/3.jpg",
//       location: "Vijay Nagar, Jabalpur",
//     },
//   ];

//   return (
//     <div
//       ref={sectionRef}
//       className="container mx-auto my-32 max-w-[90vw]"
//       style={{ fontFamily: "Gambetta" }}
//     >
//       <div className="mb-12 flex items-center justify-center">
//         <h1
//           ref={titleRef}
//           className="text-3xl lg:text-5xl"
//           style={{ fontFamily: "GT-Ultra" }}
//         >
//           Ongoing Developments
//         </h1>
//       </div>
//       <div ref={sliderRef} className="relative">
//         <Slider {...settings}>
//           {OngoingProjects.map((project, index) => (
//             <div key={index} className="px-4 focus:outline-none">
//               <img
//                 src={project.img}
//                 alt={`Ongoing Project ${index + 1}`}
//                 className="h-80 w-full rounded-lg object-cover focus:outline-none"
//               />
//               <h1
//                 className="mt-4 flex items-center justify-center text-lg tracking-widest text-[#1a4fa3]"
//                 style={{ fontFamily: "HistoryPro" }}
//               >
//                 <FaMapMarkerAlt className="mr-2" /> {project.location}
//               </h1>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// };

// const TestimonialCarousel: FC = () => {
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const titleRef = useRef<HTMLHeadingElement>(null);
//   const sliderRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     // Initialize animations
//     if (titleRef.current) {
//       titleRef.current.style.opacity = "0";
//       titleRef.current.style.transform = "translateY(30px)";
//       titleRef.current.style.transition =
//         "opacity 0.8s ease, transform 0.8s ease";
//     }

//     if (sliderRef.current) {
//       sliderRef.current.style.opacity = "0";
//       sliderRef.current.style.transform = "translateY(40px)";
//       sliderRef.current.style.transition =
//         "opacity 1s ease 0.3s, transform 1s ease 0.3s";
//     }

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             if (entry.target === sectionRef.current) {
//               // Animate title with a fade-in effect
//               if (titleRef.current) {
//                 titleRef.current.style.opacity = "1";
//                 titleRef.current.style.transform = "translateY(0)";
//               }

//               // Animate slider with a slight delay
//               if (sliderRef.current) {
//                 setTimeout(() => {
//                   sliderRef.current!.style.opacity = "1";
//                   sliderRef.current!.style.transform = "translateY(0)";
//                 }, 200);
//               }
//             }
//           }
//         });
//       },
//       {
//         threshold: 0.1,
//         rootMargin: "-50px",
//       },
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, []);

//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     dots: true,
//     slidesToScroll: 3,
//     arrows: true,
//     prevArrow: <CustomPrevArrow />,
//     nextArrow: <CustomNextArrow />,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const testimonials = [
//     {
//       img: "/Testimonials/3.webp",
//       title: "Nakshtra Nagar Families",
//       location: "Karmeta Jabalpur",
//     },
//     {
//       img: "/Testimonials/2.webp",
//       title: "Nakshtra Nagar Families",
//       location: "Karmeta Jabalpur",
//     },
//     {
//       img: "/Testimonials/1.webp",
//       title: "Nakshtra Nagar Families",
//       location: "Karmeta Jabalpur",
//     },
//   ];

//   return (
//     <div
//       ref={sectionRef}
//       className="container mx-auto my-32 max-w-[90vw]"
//       style={{ fontFamily: "Gambetta" }}
//     >
//       <div className="mb-12 flex items-center justify-center">
//         <h1
//           ref={titleRef}
//           className="text-3xl lg:text-5xl"
//           style={{ fontFamily: "GT-Ultra" }}
//         >
//           Voice of Trust
//         </h1>
//       </div>
//       <div ref={sliderRef} className="relative">
//         <Slider {...settings}>
//           {testimonials.map((item, index) => (
//             <div key={index} className="px-4 text-center focus:outline-none">
//               <img
//                 src={item.img}
//                 alt={`Ongoing Project ${index + 1}`}
//                 className="h-48 w-full rounded-lg object-cover focus:outline-none lg:h-60"
//               />
//               <div className="mt-2">
//                 <p className="text-xl">{item.title}</p>
//                 <p className="text-[#1a4fa3]">{item.location}</p>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// };

// const Homepage = () => {
//   const slides = [
//     { id: 1, image: "/Hero Carousel/_1.jpg", title: "Slide 1" },
//     { id: 2, image: "/Hero Carousel/_2.jpg", title: "Slide 2" },
//     { id: 3, image: "/Hero Carousel/_3.jpg", title: "Slide 3" },
//     { id: 4, image: "/Hero Carousel/_4.jpg", title: "Slide 5" },
//   ];

//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     fade: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//   };

//   const isLoading = null;

//   if (isLoading) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-white">
//         <p className="text-gray-600">Loading...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen">
//       <section className="relative overflow-hidden">
//         <Slider {...settings}>
//           {slides.map((slide) => (
//             <div key={slide.id}>
//               <img
//                 src={slide.image}
//                 alt={slide.title}
//                 className="h-screen w-full object-cover"
//               />
//             </div>
//           ))}
//         </Slider>

//         <CenturyCountdown />

//         <KeyBusiness />

//         <MultipleItems />

//         <TestimonialCarousel />
//       </section>
//     </div>
//   );
// };

// export default Homepage;

// Grok Optimised Code
